import React, { useMemo } from 'react';
import cn from 'clsx';
import { StyledUtpCard, utpCardOrientationMap, utpCardSizeMap, utpCardTypeMap } from './utp-card-styles';
import { UtpCardOrientation, UtpCardSize, UtpCardType } from './utp-card-types';

type UtpCardProps = {
  children: React.ReactNode;
  type: UtpCardType;
  orientation?: UtpCardOrientation;
  size?: UtpCardSize;
  cardClassName?: string;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const UtpCard: React.FC<UtpCardProps> = ({
  children,
  orientation = 'vertical',
  size,
  type,
  cardClassName,
  ...rest
}) => {
  const cardStyles = useMemo(
    () =>
      cn(utpCardTypeMap[type], {
        [utpCardSizeMap[size as UtpCardSize]]: size,
        [utpCardOrientationMap[orientation]]: orientation,
      }),
    [orientation, size, type]
  );

  return (
    <StyledUtpCard className={cn(cardStyles, cardClassName)} {...rest}>
      {children}
    </StyledUtpCard>
  );
};
